module.exports = __webpack_public_path__ + "img/1869.4a7edd76.gif";